import coreModule from 'app/core/core_module';

export class SensorSrv {
  map = {};

  /* @ngInject */
  constructor(private backendSrv, private $q) {}

  init() {
    return this.$q((resolve, reject) => {
      this.backendSrv.searchSensors().then(sensors => {
        for (let sensor of sensors) {
          this.map[sensor.shortName.toLowerCase()] = sensor;
        }
        resolve();
      });
    });
  }

  get(shortName) {
    let key = shortName.toLowerCase();
    return this.map[key];
  }

  getAll() {
    return this.map;
  }
}

coreModule.service('sensorSrv', SensorSrv);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./public/app/core/services/sensor_srv.ts